import { LOAD_COMPANY, SELECT_COMPANY, CLEAN_SELECTED_COMPANY } from "../actions/actionTypes";

const initialState = {
    companies: [],
    selectedCompany: null
};

export const companyReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_COMPANY:
            return {
                ...state,
                companies: action.companies
            };
        case SELECT_COMPANY:
            return {
                ...state,
                selectedCompany: action.company
            };
        case CLEAN_SELECTED_COMPANY:
            return {
                ...state,
                selectedCompany: null
            };
        default:
            return state;
    }
};